const INITIAL_STATE = {
  chartsPanel: {},
  pickingRankings: [],
  conferenceRankings: [],
  storageRankings: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_PRODUCTIVITY_RANKING_USER_BRANCHES': {
      return { ...state, userBranches: action.userBranches };
    }
    case 'SET_PRODUCTIVITY_RANKING_CHARTS': {
      return { ...state, chartsPanel: action.chartsPanel };
    }
    case 'SET_PRODUCTIVITY_RANKING_SELECTED_BRANCHES': {
      return { ...state, selectedBranches: action.selectedBranches };
    }
    case 'SET_PRODUCTIVITY_RANKING_DATES': {
      return { ...state, dates: action.dates };
    }
    case 'SET_PICKING_RANKINGS': {
      return { ...state, pickingRankings: action.pickingRankings };
    }
    case 'SET_CONFERENCE_RANKINGS': {
      return { ...state, conferenceRankings: action.conferenceRankings };
    }
    case 'SET_STORAGE_RANKINGS': {
      return { ...state, storageRankings: action.storageRankings };
    }
    default:
      return state;
  }
};
